module.exports = __webpack_public_path__ + "static/img/enterpriseCulture.fbd190d5.png";